import {FascicoloFull} from '../../../../common/models/fascicolo/fascicolo-full';
import {QuestionBase} from '../../../../core/components/dynamic-form/models/question-base';

export class FascicoloPrecetto extends FascicoloFull {
  sezione: string;
  titoloContestualeAlPrecetto: boolean;
  numDecretoIngiuntivoRiferimento: string;
  valoreDecretoIngiuntivoRiferimento: number;

  constructor() {
    super();
    this.dataInizioFascicolo = +new Date();
  }

  get form(): QuestionBase[] {
    return this.baseForm.concat([
      {
        key: 'numDecretoIngiuntivoRiferimento',
        label: 'N° ruolo/decreto',
        required: false,
        controlType: 'textbox',
        placeholder: 'Inserire N° ruolo/decreto',
        size: 'sm-4',
        type: 'number',
        value: this.numDecretoIngiuntivoRiferimento
      },
      {
        key: 'valoreDecretoIngiuntivoRiferimento',
        label: 'Valore',
        required: false,
        controlType: 'textbox',
        placeholder: 'Inserire Valore',
        size: 'sm-4',
        type: 'number',
        value: this.valoreDecretoIngiuntivoRiferimento
      },
      {
        key: 'titoloContestualeAlPrecetto',
        label: 'Titolo esecutivo contestuale',
        required: false,
        controlType: 'radio',
        size: 'sm-4',
        value: this.titoloContestualeAlPrecetto
      }
    ] as QuestionBase[])
  }
}
